const initialState = {
  uploadError: {},
  loading: false,
  repairInspectionReportData: {},
};

const repairInspectionReport = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'REPAIR_INSPECTION_REPORT_CREATE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'REPAIR_INSPECTION_REPORT_CREATE_SUCCESS':
      return {
        ...state,
        loading: false,
        repairInspectionReportData: payload.repairInspectionReportData,
        uploadError: '',
      };
    case 'REPAIR_INSPECTION_REPORT_CREATE_FAILURE':
      return {
        ...state,
        repairInspectionReportData: {},
        loading: false,
        uploadError: payload.errors,
      };
    default:
      return state;
  }
};

export default repairInspectionReport;



// WEBPACK FOOTER //
// ./client/app/reducers/repair_inspection_report.js